import Vue from "vue";
import App from "./App";
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
Vue.use(VueSidebarMenu)

import * as VueWindow from '@hscmap/vue-window'
Vue.use(VueWindow)

Vue.config.productionTip = false;

//----------------------------------------------------
//date time
//----------------------------------------------------
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)

//----------------------------------------------------
//color picker
//----------------------------------------------------
import InputColorPicker from "vue-native-color-picker";
Vue.use(InputColorPicker);

//----------------------------------------------------
//firebase configuration
//----------------------------------------------------
import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyB3SuZMjPX-axvoprWr2cFu_wLpqqYoLI8",
  authDomain: "satrifo.firebaseapp.com",
  databaseURL: "https://satrifo.firebaseio.com",
  projectId: "satrifo",
  storageBucket: "satrifo.appspot.com",
  messagingSenderId: "786094056719",
  appId: "1:786094056719:web:aa8d17356836805897ca7a",
  measurementId: "G-P0CM2K5Q5R"
};
// Initialize Firebase
initializeApp(firebaseConfig);

new Vue({
  el: "#app",
  components: { App },
  template: "<App/>"
});

